import shuffle from 'lodash/shuffle';
import noimage from './components/Pair/no-image.png';

class DataApi {
  constructor(rawData) {
    this.rawData = rawData;
  }

  createPairs(pairs, projectObjects) {
    let output = [];
    if (pairs.length < 2) {
      return output;
    }
    pairs.forEach(pair => {
      const first = projectObjects.find(projectObject => {
        if (projectObject.id === pair.first) {
          return true;
        }
        return false;
      });

      const second = projectObjects.find(projectObject => {
        if (projectObject.id === pair.second) {
          return true;
        }
        return false;
      });

      output.push({
        projectObjects: [first, second],
        answered: false,
        skipped: false,
        answer: {
          term: null,
          opposite: null
        }
      });
    });
    return output;
  }

  setupData() {
    let newData = {
      numOfElements: this.rawData.num_rounds,
      project: this.rawData.uuid,
      enabledProjectObjects: [],
      questions: [],
      aspects: [],
      objectPairs: [],
      projectObjects: []
    };

    this.rawData.project_objects.forEach(projectObject => {
      if (!projectObject.image) {
        projectObject.image = noimage;
      }
      projectObject.aspects = [];
      if (projectObject.enabled) {
        newData.enabledProjectObjects.push(projectObject);
      }
      newData.projectObjects.push(projectObject);
    });

    this.rawData.questions.forEach(question => {
      question.skipped = false;
      question.answered = false;
      question.answer = [];
      newData.questions.push(question);
    });

    newData.objectPairs = this.createPairs(
      this.rawData.project_object_pairs_projects,
      newData.projectObjects
    );
    newData.objectPairs = shuffle(newData.objectPairs);
    let i = 0;
    newData.objectPairs.forEach(objectPair => {
      objectPair.pairId = i++;
    });

    newData.enabledProjectObjects = shuffle(newData.enabledProjectObjects);
    newData.questions = shuffle(newData.questions);

    newData.output = {
      project: newData.project,
      questions: [],
      aspects: [],
      projectObjects: newData.projectObjects
    };

    return newData;
  }
}

export default DataApi;



// WEBPACK FOOTER //
// ./src/comparison/DataApi.js